import { IControl, IField } from 'app/services/api5-service/api.interface';
import { map } from 'rxjs/operators';

import { ISPFieldConfig, ISPFormState, ISPValidator } from '../../model';
import { addValidator } from '../add-validator';
import { FIELD_HIDDEN_CLASS } from '../class-fields';
import { getLayoutPlace } from '../get-layout-place';

/**
 * Append the common field options. Contains common members and wrapper fields
 *
 * @param config - config to append
 * @param control - control (subfield) metadata
 * @param field - field metadata
 * @param state - dynamic form state
 * @param defaultValue - default value of field in model
 */
export function appendConfigCommonOptions(
  config: ISPFieldConfig,
  control: IControl,
  field: IField,
  state: ISPFormState,
  defaultValue?: any,
): void {
  // setValues should not be requested on every letter input, because this field may also be updated with an old value
  if (control.$setvalues) {
    config.modelOptions = {
      updateOn: 'blur',
      ...config.modelOptions,
    };
  }

  if (defaultValue !== undefined) {
    config.defaultValue = defaultValue;
  }

  const isHidden$ = state.hiddenService.isHidden$(control.$name, field.$name);

  config.props = {
    required: control.$required === 'yes',
    disabled: state.disabledService.isFieldDisabled(control.$name),
    isHidden: state.hiddenService.isHidden(control.$name, field.$name),
    isHidden$,
    layoutPlace: getLayoutPlace(control, field),
    ...config.props,
  };
  config.expressions = {
    'props.disabled': state.disabledService.isFieldDisabled$(control.$name),
    'props.isHidden': config.props.isHidden$!,
    className: config.props.isHidden$!.pipe(
      map(isHidden => (isHidden ? FIELD_HIDDEN_CLASS : '')),
    ),
    ...config.expressions,
  };

  state.formService.appendHooks(config);

  if (config.props.required) {
    addValidator(config, ISPValidator.Required);
  }
}
